import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { bindActionCreators } from 'redux';
import { Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import LeisureTravelFormContainer from './LeisureTravelFormContainer';
import getIncludedResource from '../../../helpers/getIncludedResource';
import { actions as customerActions } from '../../customer/redux/customerActions';
import { actions as productActions } from '../redux/productActions';
import { getPolicy } from '../../policy/redux/policyActions';
import { actions as channelActions } from '../../channel/redux/channelActions';
import { actions as brokerActions } from '../../broker/redux/brokerActions';
import LeavingContainer from './LeavingContainer';
import { getBrokerId, isBroker } from '../../auth/redux/authActions';
import PersonalAccidentFormContainer from './PersonalAccidentFormContainer';
import SourceSelect from '../components/SourceSelect/SourceSelect';
import { openMenu } from '../../layout/redux/sideNavAction';
import SmartLuggageFormContainer from './SmartLuggageFormContainer';
import { getMarketingFlags } from '../helpers';

export class ProductQuoteContainer extends Component {
  state = {
    nextLocation: null,
    currentOrganisation: '',
    selectedSource: null,
    marketingFlags: null,
  };

  componentDidMount() {
    const {
      params: { applicationId, id },
      dispatch,
      productActions,
      customerActions,
      brokerActions,
      user,
      location: {
        query: { clone, customer },
      },
      brokerState,
    } = this.props;

    productActions.getProduct(id);
    productActions.setPremiumIndication({});
    productActions.setPremiumOverrideCalculation({});
    const currentOrganisation = getIncludedResource(
      user.data,
      user.included,
      'current_organisation',
    );
    this.setState({
      currentOrganisation: currentOrganisation.data.attributes.name,
    });

    if (isBroker()) {
      if (!get(brokerState, `resources[${getBrokerId()}]`)) {
        brokerActions.getBroker(getBrokerId());
      }
    }

    const isApplication = applicationId && (clone ? clone === 'quote' : true);

    if (applicationId) {
      Promise.resolve(
        dispatch(
          getPolicy(applicationId, isApplication, [
            'customer',
            'broker',
            'user',
            'schemes',
            'channel',
            'campaign',
            'source',
            'product',
          ]),
        ),
      ).then((resp) => {
        const channel = getIncludedResource(resp.data, resp.included, 'channel');
        const source = getIncludedResource(resp.data, resp.included, 'source');
        const broker = getIncludedResource(resp.data, resp.included, 'broker');

        const marketingFlags = getMarketingFlags(broker.data, channel.data);
        this.setState({
          selectedSource: source.data,
          marketingFlags,
        });
      });
    }
    if (customer) {
      customerActions.getCustomer(customer, []);
    }

    if (isBroker()) {
      const currentBroker = getIncludedResource(
        user.data,
        user.included,
        'current_broker',
      );
      const marketingFlags = getMarketingFlags(currentBroker?.data, null);
      this.setState({
        marketingFlags,
      });
    }
    dispatch(openMenu(false));
    this.props.router.setRouteLeaveHook(this.props.route, ::this.routerWillLeave);
  }

  cancelLeave = () => {
    this.setState({
      nextLocation: null,
    });
  };

  attemptLeave = (location) => {
    this.setState({
      nextLocation: location,
    });
  };

  routerWillLeave(nextLocation) {
    const { user, router } = this.props;
    const currentOrganisation = getIncludedResource(
      user.data,
      user.included,
      'current_organisation',
    );

    if (nextLocation.state && nextLocation.state.leaveConfirmed) {
      return true;
    }

    if (this.props.productState.submitSucceeded || nextLocation.pathname === '/login') {
      return true;
    }

    // Do not display the confirm dialog for logout and if the user changed the Organisation by Settings -> Organisation Settings
    if (
      this.state.currentOrganisation === currentOrganisation.data.attributes.name &&
      nextLocation.pathname !== '/'
    ) {
      this.attemptLeave(nextLocation);
    } else {
      router.push(nextLocation);
    }
    return false;
  }

  onModalClose() {
    this.setState(() => ({
      nextLocation: null,
    }));
  }

  componentWillUnmount() {
    const { productActions } = this.props;
    productActions.clearData();
  }

  getCurrentBrokerSource() {
    const { user } = this.props;
    if (isBroker()) {
      const currentBroker = getIncludedResource(
        user.data,
        user.included,
        'current_broker',
      );
      const brokerSources = getIncludedResource(
        currentBroker.data,
        user.included,
        'sources',
      );
      const sources = Array.isArray(brokerSources) ? brokerSources : [];
      return sources.find(
        (source) => source.attributes.is_broker && !source.attributes.is_channel,
      );
    }
    return null;
  }

  getCurrentBrokerB2CChannel() {
    const { user } = this.props;
    if (isBroker()) {
      const currentBroker = getIncludedResource(
        user.data,
        user.included,
        'current_broker',
      );
      const channel = getIncludedResource(currentBroker.data, user.included, 'channel');
      return channel.data.attributes ? channel : null;
    }
    return null;
  }

  render() {
    const {
      productResources,
      brokerResources,
      policyResources,
      customerResources,
      customerSearchData,
      params: { id, applicationId },
      location: {
        query: { clone, customer },
      },
      user,
      customerState,
    } = this.props;

    const { marketingFlags, selectedSource, nextLocation } = this.state;
    const resource = productResources[id];
    const application = policyResources[applicationId];
    const searchedCustomerValues = customerSearchData
      ? {
          data: {
            attributes: {
              ...customerSearchData,
            },
          },
        }
      : undefined;

    const searchedCustomer = customerResources[customer] || searchedCustomerValues;
    const mta =
      get(application, 'data.attributes.quote_type', 'new business') ===
      'mid term adjustment';
    const policyId = mta
      ? get(application, 'data.relationships.policy.data.id', null)
      : null;
    const edit = get(application, 'data.attributes.quote_type') === 'new business';
    const renewal = get(application, 'data.attributes.quote_type') === 'renewal';

    const handleSourceChange = (source) => {
      if (source) {
        const marketingFlags = getMarketingFlags(
          source?.broker?.data,
          source?.channel?.data,
        );
        this.setState({
          selectedSource: source.value,
          marketingFlags,
        });
      }
    };

    const brokerType = get(selectedSource, 'attributes.broker_type');

    const brokerId = isBroker()
      ? get(brokerResources, `${getBrokerId()}.data.id`)
      : get(selectedSource, 'relationships.broker.data.id');
    const brokerReady = isBroker() ? !!brokerId : true;
    const customerReady = !customer || (customer && searchedCustomer);
    const applicationReady = !applicationId || (applicationId && application);
    const readyForRender = customerReady && applicationReady;

    if (!resource || !readyForRender || !brokerReady) {
      return (
        <InternalContainer hideBreadcrumbs title={'Get a Quote'} bottomBar>
          <Loader />
        </InternalContainer>
      );
    }

    const channelId = get(selectedSource, 'relationships.channel.data.id');

    const sourceFilters = [
      {
        type: 'status',
        match: 'active',
      },
      {
        type: 'product',
        match: id,
      },
    ];

    const source = application
      ? getIncludedResource(application.data, application.included, 'source')
      : undefined;

    if (!isEmpty(source?.data)) {
      sourceFilters.push({
        type: 'name',
        match: get(source, 'data.attributes.name'),
      });
    }
    const journey = resource.data.attributes.metadata.quote_journey;

    const isBrokerType = brokerType === 'broker' || !brokerType;
    const isBrokerChannel = !channelId && brokerId && isBrokerType;

    if (journey === 'personal_accident') {
      return (
        <InternalContainer hideBreadcrumbs title={'Get a Quote'}>
          <SourceSelect
            handleSourceChange={handleSourceChange}
            isClearable={!mta}
            isDisabled={mta || edit}
            sourceFilters={sourceFilters}
            value={source?.data}
          />
          <PersonalAccidentFormContainer
            source={isBroker() ? this.getCurrentBrokerSource() : selectedSource}
            brokerId={brokerId}
            isBrokerChannel={isBrokerChannel}
            channelId={channelId}
            policyId={policyId}
            productId={id}
            isEditingQuote={edit}
            isRenewal={renewal}
            application={application}
            currentProduct={resource}
            isCloned={clone}
            user={user}
            customer={customerState.resources[customer]}
          />
          <LeavingContainer
            next={nextLocation}
            handleClose={this.cancelLeave}
            mta={mta}
          />
        </InternalContainer>
      );
    }
    if (journey === 'smart_luggage') {
      return (
        <InternalContainer hideBreadcrumbs={true} title={'Get a Quote'} bottomBar={true}>
          <SourceSelect
            handleSourceChange={handleSourceChange}
            isClearable={!mta}
            isDisabled={mta || edit}
            sourceFilters={sourceFilters}
            value={source?.data}
          />
          <SmartLuggageFormContainer
            application={application}
            currentProduct={resource}
            source={
              isBroker() ? this.getCurrentBrokerSource() : this.state.selectedSource
            }
            brokerId={brokerId}
            channelId={channelId}
            isBrokerChannel={isBrokerChannel}
            policyId={policyId}
            productId={id}
            isCloned={clone}
            user={user}
            customer={customerState.resources[customer]}
            isMta={false}
          />
          <LeavingContainer
            next={this.state.nextLocation}
            handleClose={this.cancelLeave}
            mta={mta}
          />
        </InternalContainer>
      );
    }

    return (
      <InternalContainer hideBreadcrumbs title={'Get a Quote'}>
        <SourceSelect
          handleSourceChange={handleSourceChange}
          isClearable={!mta}
          isDisabled={mta || edit}
          sourceFilters={sourceFilters}
          value={source?.data}
        />

        <LeisureTravelFormContainer
          source={isBroker() ? this.getCurrentBrokerSource() : this.state.selectedSource}
          brokerId={brokerId}
          brokerType={brokerType}
          channelId={channelId}
          policyId={policyId}
          productId={id}
          mta={mta}
          edit={edit}
          isRenewal={renewal}
          application={application}
          currentProduct={resource}
          clone={clone}
          user={user}
          customer={searchedCustomer}
          isMarketingEnabled={marketingFlags?.marketing_enabled}
          isInsuranceMarketingOptionsEnabled={
            marketingFlags?.insurance_marketing_options_enabled
          }
          isCarInsuranceMarketingEnabled={marketingFlags?.car_insurance_marketing_enabled}
          isHomeInsuranceMarketingEnabled={
            marketingFlags?.home_insurance_marketing_enabled
          }
        />
        <LeavingContainer
          next={this.state.nextLocation}
          handleClose={this.cancelLeave}
          mta={mta}
        />
      </InternalContainer>
    );
  }
}

export default connect(
  (state) => ({
    brokerState: state.broker,
    customerState: state.customer,
    productState: state.product,
    productResources: state.product.resources,
    policyResources: state.policy.resources,
    brokerResources: state.broker.resources,
    customerResources: state.customer.resources,
    schemes: state.product.schemes,
    submitSucceeded: state.product.submitSucceeded,
    policyState: state.policy,
    user: state.auth.user,
    nextState: state.modal,
    customerSearchData: get(state, 'customerSearch.searchedData.metadata'),
  }),
  (dispatch) => ({
    customerActions: bindActionCreators(customerActions, dispatch),
    productActions: bindActionCreators(productActions, dispatch),
    channelActions: bindActionCreators(channelActions, dispatch),
    brokerActions: bindActionCreators(brokerActions, dispatch),
    dispatch,
  }),
)(ProductQuoteContainer);
